export default __webpack_public_path__ + "static/canon_mob-9ae8221bcd9cfe0bf600672e5d51b91c.png";